import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useState } from "react";
import JournalSummaryTable from "./JournalSummaryTable";
import JournalExplorer from "./JournalExplorer";

function PortfolioJournalExplorer() {

    const [value, setValue] = useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };


    interface TabPanelProps {
        children?: React.ReactNode;
        index: number;
        value: number;
    }

    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    function CustomTabPanel(props: TabPanelProps) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <Box>{children}</Box>}
            </div>
        );
    }

    return <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="Portfolio tools">
            <Tab label="Journal Summary" {...a11yProps(0)} />
            <Tab label="Journal Explorer" {...a11yProps(1)} />
        </Tabs>
        <CustomTabPanel value={value} index={0}>
            <JournalSummaryTable mode="explorer" />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
            <JournalExplorer initialJournalId={undefined} />
        </CustomTabPanel>
    </Box>
}

export default PortfolioJournalExplorer;